import type { VisitClosureFormData } from "./schemas";

type PostEncounterActivity =
  VisitClosureFormData["encounterTimeData"]["postEncounterActivities"][number];

export const POST_ENCOUNTER_ACTIVITY_LABELS = {
  "work-note": "Work Note",
  "review-additional-records": "Review Additional Records",
  referral: "Referral",
  "imaging-order": "Imaging Orders",
  "ma-coordination": "MA Care Coordination",
} satisfies Record<PostEncounterActivity["activityType"], string>;
